import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import i18n from '@/api/i18n/i18n';

Vue.use(VueToast);

export const TOAST_TYPE = {
  INFO: 'info',
  ERROR: 'error',
  SUCCSESS: 'success',
  WARNING: 'warning',
  DEFAULT: 'default',
};

export const openToast = (message, type) => {
  Vue.$toast.open({
    message,
    type,
  });
};

export const errorToast = () => openToast(i18n.t('toast.unknownError'), TOAST_TYPE.ERROR);
